import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/maintenance',
  component: LAYOUT,
  name: 'Maintenance',
  redirect: '/maintenance/appointment',
  meta: {
    title: '预约维保',
  },
  children: [
    {
      path: 'appointment',
      name: 'MaintenanceAppointment',
      meta: {
        title: '预约维保',
      },
      component: () => import('@/views/maintenance/appointment/index.vue'),
    },
    {
      path: 'records',
      name: 'MaintenanceRecords',
      meta: {
        title: '维保订单',
      },
      component: () => import('@/views/maintenance/appointment/records.vue'),
    },
    {
      path: 'detail',
      name: 'MaintenanceDetail',
      meta: {
        title: '订单详情',
      },
      component: () => import('@/views/maintenance/appointment/detail.vue'),
    },
    {
      path: 'progress',
      name: 'MaintenanceProgress',
      meta: {
        title: '服务进度查询',
      },
      component: () => import('@/views/maintenance/appointment/progress.vue'),
    },
  ],
};
